module.exports = __webpack_public_path__ + "img/template-03.b169992d.svg";